import React from 'react';
import { Modal } from 'semantic-ui-react';
import clsx from 'clsx';
import download from '@/utils/downloads';
import DialogWrapper from './DialogWrapper';
import CloseButton from '../buttons/CloseButton';
import DownloadButton from '../buttons/DownloadButton';
import TrimmedMarkdownRender from '../text-editors/TrimmedMarkdownRender';

const MarkdownDialog = ({
  children,
  className,
  hide,
  modalIcon,
  name,
  suffix = '',
  text,
  theme,
}) => (
  <DialogWrapper
    className={clsx('aridhia-markdown-dialog', className, 'smallwizard')}
    icon={modalIcon}
    onClose={hide}
    size="small"
    theme={theme}
    title={name}
  >
    <Modal.Content scrolling>
      {children}
      <TrimmedMarkdownRender text={text} />
    </Modal.Content>
    <Modal.Actions>
      <CloseButton onClick={hide} messageId="actions.close" />
      <DownloadButton
        onClick={() => download.textDownload(text, `${name}${suffix}.md`)}
        positive
      />
    </Modal.Actions>
  </DialogWrapper>
);

export default MarkdownDialog;
